import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogProps, DialogTitle, IconButton, SxProps, Theme, Typography } from '@mui/material';
import React from 'react';
import { useHistory } from 'react-router-dom';

import { LOGIN_PATH } from 'models/Paths';
import Icon from '../Icon/Icon';
import './IconModal.scss';

interface IIconModalProps extends DialogProps {
    open: boolean;
    icon?: React.ReactNode;
    title?: string;
    text?: React.ReactNode;
    imageComponent?: React.ReactNode;
    button?: {
        title: string;
        disabled?: boolean;
        onClick(): void;
        sx?: SxProps<Theme>;
    };
    onClose(): void;
}


export const IconModal = (props: IIconModalProps) => {
    const { open, onClose, title, text, icon, button, imageComponent, children } = props;
    const history = useHistory();

    return (
        <Dialog
            open={open}
            onClose={onClose}
            sx={{ zIndex: 2147483647 }}
            PaperProps={{
                style: { overflow: 'visible' },
                className: 'text-align-center icon-modal__paper',
                // force a very high stacking order so it always renders above cards/grids
                sx: { zIndex: 2147483647, position: 'relative' },
            }}
            BackdropProps={{
                sx: { zIndex: 2147483646 },
            }}
            maxWidth="xs"
            fullWidth
        >
            <IconButton className="icon-modal__close" size="small" onClick={onClose}>
                <Icon icon={faTimes} fontSize="small" />
            </IconButton>

            {title && (
                <DialogTitle>
                    <Typography variant="h6" style={{
                        margin: '1em 0 0 0'
                    }} sx={{ m: {xs: 0, sm: '1em 0 0 0'}}}>{title}</Typography>
                </DialogTitle>
            )}
            <DialogContent sx={{ p: {xs: 0, sm: 2} }}>
                {text && <DialogContentText>{text}</DialogContentText>}
                {children}
            </DialogContent>
            <Box
            className="icon-modal__icon"
            sx={{
                position: 'absolute',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
            >
            {imageComponent
                ? imageComponent
                : typeof icon === 'string'
                ? <img src={icon} alt="modal-icon" style={{ maxWidth: 64, maxHeight: 64 }} />
                : icon}
            </Box>

            {button && (
                <Button variant="contained" color='primary' fullWidth={false} onClick={button.onClick} disabled={button.disabled} sx={button.sx}>
                    {button.title}
                </Button>
            )}
        </Dialog>
    );
};

export default IconModal;

